import React from 'react'

export const Logo = () => (
	<>
		<polygon
			fill="white"
			points="82.8,48.3 82.8,54.2 81.5,54.2 81.5,48.3 80.3,48.3 80.3,47.5 84,47.5 84,48.3 "
		/>
		<rect x="99.5" y="47.5" fill="white" width="1.3" height="6.8" />
		<path
			fill="white"
			d="M87.6,48.2c-1,0-1.3,1.3-1.3,2.6c0,1.3,0.2,2.6,1.3,2.6c1.1,0,1.3-1.3,1.3-2.6C88.8,49.5,88.6,48.2,87.6,48.2
	 M87.6,54.3c-1.8,0-2.6-1.6-2.6-3.5c0-1.9,0.7-3.5,2.6-3.5c1.8,0,2.5,1.6,2.5,3.5C90.1,52.8,89.4,54.3,87.6,54.3"
		/>
		<polygon
			fill="white"
			points="93.6,48.3 93.6,54.2 92.3,54.2 92.3,48.3 91.1,48.3 91.1,47.5 94.9,47.5 94.9,48.3 "
		/>
		<polygon
			fill="white"
			points="102.7,54.2 102.7,47.5 106,47.5 106,48.3 104,48.3 104,50.3 105.8,50.3 105.8,51.2 104,51.2 104,53.4 
	106,53.4 106,54.2 "
		/>
		<path
			fill="white"
			d="M109.5,48.2c-0.3,0-0.5,0-0.6,0.1v5.1c0.1,0,0.4,0.1,0.7,0.1c1.2,0,1.6-0.8,1.6-2.7
	C111.2,49,110.7,48.2,109.5,48.2 M109.6,54.3c-0.8,0-1.5-0.1-1.9-0.4v-6.2c0.4-0.2,1.1-0.4,1.9-0.4c2,0,2.9,1.4,2.9,3.4
	C112.4,52.8,111.6,54.3,109.6,54.3"
		/>
		<polygon
			fill="white"
			points="114.1,54.2 114.1,47.5 117.4,47.5 117.4,48.3 115.4,48.3 115.4,50.3 117.2,50.3 117.2,51.2 115.4,51.2 
	115.4,53.4 117.4,53.4 117.4,54.2 "
		/>
		<path
			fill="white"
			d="M120.9,48.1c-0.3,0-0.5,0-0.6,0.1v2.7c0.1,0,0.3,0,0.5,0c1,0,1.4-0.5,1.4-1.4C122.2,48.5,121.8,48.1,120.9,48.1
	 M122.2,54.2l-1.9-3.1h0v3.1h-1.2v-6.5c0.4-0.2,1.1-0.4,1.9-0.4c1.7,0,2.5,0.8,2.5,2.1c0,1-0.7,1.7-1.8,1.8v0l2,3H122.2z"
		/>
		<polygon
			fill="white"
			points="125.1,54.2 125.1,47.5 128.4,47.5 128.4,48.3 126.4,48.3 126.4,50.3 128.2,50.3 128.2,51.2 126.4,51.2 
	126.4,53.4 128.4,53.4 128.4,54.2 "
		/>
		<polygon
			fill="white"
			points="130,54.2 130,47.5 133.3,47.5 133.3,48.3 131.3,48.3 131.3,50.3 133.1,50.3 133.1,51.2 131.3,51.2 
	131.3,53.4 133.3,53.4 133.3,54.2 "
		/>
		<path
			fill="white"
			d="M139,54.2l-2.6-4.4c-0.2-0.4-0.4-0.8-0.4-0.8h0c0,0,0,0.4,0,0.8v4.3H135v-6.8h1.2l2.4,4.1
	c0.2,0.4,0.4,0.7,0.4,0.7h0c0,0,0-0.3,0-0.7v-4.1h1v6.8H139z"
		/>
		<path
			fill="white"
			d="M150.5,54.2c0-0.2-0.4-4.5-0.4-4.5c0-0.4,0-0.8,0-0.8h0c0,0-0.1,0.4-0.2,0.8c0,0-1.2,4.3-1.3,4.5h-0.7
	c-0.1-0.2-1.3-4.5-1.3-4.5c-0.1-0.4-0.2-0.8-0.2-0.8h0c0,0,0,0.4,0,0.8c0,0-0.4,4.3-0.4,4.5h-1.1l0.8-6.8h1.3l1.2,4.3
	c0.1,0.4,0.2,0.8,0.2,0.8h0c0,0,0-0.3,0.2-0.8l1.3-4.3h1.3l0.8,6.8H150.5z"
		/>
		<polygon
			fill="white"
			points="153.3,54.2 153.3,47.5 156.6,47.5 156.6,48.3 154.6,48.3 154.6,50.3 156.4,50.3 156.4,51.2 154.6,51.2 
	154.6,53.4 156.6,53.4 156.6,54.2 "
		/>
		<polygon
			fill="white"
			points="158.3,54.2 158.3,47.5 161.5,47.5 161.5,48.3 159.5,48.3 159.5,50.3 161.3,50.3 161.3,51.2 159.5,51.2 
	159.5,53.4 161.5,53.4 161.5,54.2 "
		/>
		<rect x="166.4" y="47.5" fill="white" width="1.3" height="6.8" />
		<path
			fill="white"
			d="M170.9,54.3c-0.8,0-1.3-0.1-1.7-0.4l0.3-0.9c0.2,0.2,0.6,0.3,1.1,0.3c0.7,0,1.1-0.4,1.1-1
	c0-0.5-0.3-0.8-1.1-1.1c-1.1-0.5-1.4-1.2-1.4-1.9c0-1.1,0.8-2,2-2c0.7,0,1.2,0.2,1.5,0.4l-0.3,0.8c-0.2-0.1-0.6-0.3-1-0.3
	c-0.6,0-1,0.4-1,1c0,0.6,0.4,0.9,1,1.1c1.3,0.6,1.5,1.3,1.5,2C173.1,53.5,172.1,54.3,170.9,54.3"
		/>
		<path
			fill="white"
			d="M83.2,33.9h-0.4v4.4c0.3,0.1,0.6,0.2,0.9,0.2c1.3,0,2-0.8,2-2.2C85.8,34.7,85.1,33.9,83.2,33.9 M83.8,28.3
	c-0.4,0-0.7,0-1,0.1v4h0.4c1.6,0,2.3-0.5,2.3-2.2C85.5,28.9,84.9,28.3,83.8,28.3 M83.8,40.4c-1.6,0-2.8-0.3-3.6-0.8V27.2
	c0.7-0.5,1.9-0.8,3.5-0.8c2.8,0,4.4,1.4,4.4,3.6c0,1.8-1.2,2.7-2.1,3v0c1,0.3,2.4,1.3,2.4,3.4C88.5,39.3,86.3,40.4,83.8,40.4"
		/>
		<path
			fill="white"
			d="M94.2,31.5c-0.8-0.3-1.8-0.3-1.8,0.6v8.1h-2.5v-8.4c0-2.3,2.5-3.2,5.1-2.4L94.2,31.5z"
		/>
		<path
			fill="white"
			d="M135.1,31.5c-0.8-0.3-1.8-0.3-1.8,0.6v8.1h-2.5v-8.4c0-2.3,2.5-3.2,5.1-2.4L135.1,31.5z"
		/>
		<path
			fill="white"
			d="M98.8,31.2c-1.1,0-1.3,1.6-1.3,3.6c0,1.9,0.2,3.5,1.3,3.5c1.1,0,1.3-1.6,1.3-3.5
	C100.1,32.9,99.9,31.2,98.8,31.2 M98.8,40.4c-2.6,0-3.9-2.4-3.9-5.5s1.3-5.5,3.9-5.5c2.6,0,3.9,2.3,3.9,5.5S101.4,40.4,98.8,40.4"
		/>
		<path
			fill="white"
			d="M107.7,31.2c-0.9,0-1.6,1.3-1.5,3.2L109,34C109,32.2,108.6,31.2,107.7,31.2 M106.3,36c0.2,1.5,0.8,2.3,2.1,2.3
	c1.1,0,1.8-0.3,2.2-0.6l0.6,1.8c-0.7,0.5-1.7,0.8-3.1,0.8c-2.8,0-4.3-2.1-4.3-5.5c0-3.2,1.5-5.5,4-5.5c2.7,0,4,2.3,3.8,6L106.3,36z"
		/>
		<path
			fill="white"
			d="M117.7,31.2c-0.2,0-0.4-0.1-0.6-0.1c-1.5,0-1.9,1.6-1.9,3.6c0,2.3,0.5,3.7,1.8,3.7c0.2,0,0.5,0,0.7-0.1V31.2z
	 M116.9,40.4c-2.7,0-4.3-1.9-4.3-5.4c0-3.4,1.6-5.5,3.8-5.5c0.6,0,1,0.1,1.2,0.2v-4.9h2.6v14.9C119.5,40.1,118.5,40.4,116.9,40.4"
		/>
		<path
			fill="white"
			d="M125.6,31.2c-0.9,0-1.6,1.3-1.5,3.2l2.9-0.4C126.9,32.2,126.5,31.2,125.6,31.2 M124.2,36
	c0.2,1.5,0.8,2.3,2.1,2.3c1.1,0,1.8-0.3,2.2-0.6l0.6,1.8c-0.7,0.5-1.7,0.8-3.1,0.8c-2.8,0-4.3-2.1-4.3-5.5c0-3.2,1.5-5.5,4-5.5
	c2.7,0,4,2.3,3.8,6L124.2,36z"
		/>
		<rect x="136.5" y="24.7" fill="white" width="2.6" height="15.5" />
		<path
			fill="white"
			d="M140.9,29.6h2.6v10.6h-2.6V29.6z M142.1,27.8c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4
	c0.8,0,1.4,0.6,1.4,1.4C143.5,27.2,142.9,27.8,142.1,27.8"
		/>
		<path
			fill="white"
			d="M146.5,27.8c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4
	C147.9,27.2,147.3,27.8,146.5,27.8 M143.7,44.6v-2c0.8-0.3,1.5-1.1,1.5-3.3v-9.8h2.5v9.5C147.8,42.5,145.9,44.5,143.7,44.6"
		/>
		<polygon
			fill="white"
			points="154.8,40.2 152.1,34.6 152.1,34.6 152.1,40.2 149.6,40.2 149.6,24.7 152.1,24.7 152.1,34.4 152.1,34.4 
	154.9,29.6 157.4,29.6 154.4,34.4 157.6,40.2 "
		/>
		<path
			fill="white"
			d="M164.2,28.4c-0.3,0-0.6,0.1-0.8,0.1v9.5c0.2,0.1,0.5,0.1,0.8,0.1c1.7,0,2.3-1.4,2.3-5
	C166.6,30,165.9,28.4,164.2,28.4 M164.3,40.4c-1.5,0-2.7-0.3-3.5-0.8V27.2c0.8-0.5,1.9-0.8,3.3-0.8c3.7,0,5.2,3,5.2,7
	C169.3,37.2,168,40.4,164.3,40.4"
		/>
		<path
			fill="white"
			d="M174.4,31.2c-0.9,0-1.6,1.3-1.5,3.2l2.9-0.4C175.7,32.2,175.3,31.2,174.4,31.2 M173,36c0.2,1.5,0.8,2.3,2.1,2.3
	c1.1,0,1.8-0.3,2.2-0.6l0.6,1.8c-0.7,0.5-1.7,0.8-3.1,0.8c-2.8,0-4.3-2.1-4.3-5.5c0-3.2,1.5-5.5,4-5.5c2.7,0,4,2.3,3.8,6L173,36z"
		/>
		<rect x="179.6" y="24.7" fill="white" width="2.6" height="15.5" />
		<path
			fill="white"
			d="M187.6,31.2c-0.9,0-1.6,1.3-1.5,3.2l2.9-0.4C188.9,32.2,188.5,31.2,187.6,31.2 M186.2,36
	c0.2,1.5,0.8,2.3,2.1,2.3c1.1,0,1.8-0.3,2.2-0.6l0.6,1.8c-0.7,0.5-1.7,0.8-3.1,0.8c-2.8,0-4.3-2.1-4.3-5.5c0-3.2,1.5-5.5,4-5.5
	c2.7,0,4,2.3,3.8,6L186.2,36z"
		/>
		<path
			fill="white"
			d="M197.7,40.2v-7.5c0-0.9-0.4-1.4-1.3-1.4c-0.5,0-0.8,0.1-1.1,0.2v8.8h-2.5V30.1c0.8-0.5,2.1-0.8,3.7-0.8
	c2.6,0,3.8,1.1,3.8,3.3v7.5H197.7z"
		/>
		<path
			fill="white"
			d="M33.6,25c1.3,0,2-1.2,2-2.4c0-1.2-0.9-1.8-1.9-1.8c-0.8,0-1.7,0.4-2,1.1C31.2,23.3,32.3,25,33.6,25 M35.2,51.3
	c-1.5-1.8-2.7-1.6-3.5-3.5c-0.8-1.9-0.7-4.1,2-5.9c1-0.6,2.5-1.3,3-3.5c0.5-2,0.4-4.6,0.8-6.1c0.5-1.7,1.1-3.8,4.3-5.3
	c5.9-2.6,0.5-7.1-2.8-3.8c-1.1,1.1-2.8,5.2-6.2,4.5c-3.1-0.5-4-2.5-4.6-3.1c-2-2-4.6,1.5-1.9,2.8c3,1.4,3.6,2,4.6,4.1
	c0.8,1.8,0.3,4.4-2.6,2.2c-1.1-0.8-3.7-1.9-5.4-0.2c-1.7,1.7-3.9,7.2-1.4,8.1c2.8,1,3.2-3,4.3-4.1c1.1-1.1,4.4,0.9,4.4,2.2
	c0,1.2-1.4,0.6-3.1,3.2c-2.8,4.6-0.1,9.1,2,11.1C32.7,57.5,36.7,53.1,35.2,51.3 M52.9,20c0.7,0,1.6-1.5,0.8-2.5
	c-0.6-0.8-1.2-1.1-1.8-1.1c-1.1,0-1.8,1.2-1.6,1.8C50.7,19.1,52.2,20,52.9,20 M55.2,37.1c-1.9-0.9-2.6-3.7-2.6-5.3
	c0-1.7,0.9-4.9,2.1-6.1c1.3-1.3,2.7-0.5,4.4-2.2c1.5-1.5,1.7-2.7,1.7-3.7c0-2.2-1.5-3-2.6-3c-0.7,0-1.3,0.3-1.3,0.8
	c0,2.9-2.3,4.1-3.6,4.1c-2.7,0-7.5-4.9-8.9-6c-3.1-2.3-5.7,1.6-2.4,3.8c1.1,0.7,6.1,2.5,7,4.6c0.6,1.4,0.1,4.1-1.6,4.2
	c-2.1,0.2-5.4,0.8-6.7,2.2c-1.3,1.3-1.1,5.6-1.4,8.2c-0.3,2.6,3.2,1.9,4,1c0.9-0.9,0-4.3,0-5.7c0-1.5,4-1.7,4.9-0.8
	c1.1,1.1,1.3,4.1,1.9,5.6c0.6,1.5,3.6,5.1,6,4C58.5,41.8,59.6,39.1,55.2,37.1 M49.3,42.2c0.4-1.4-0.2-3.3-2.1-3.3
	c-1.9,0-1.9,1.3-1.9,2.3C45.3,42.8,48.6,44.9,49.3,42.2 M47.3,54.1c-0.6-0.6,0-3.3,0.8-4.1c0.8-0.8,1.9-0.5,4.3,0.5
	c2.2,0.9,3.1-3.3,1.9-4.1c-1.7-1-6.6-0.3-8.8-0.8c-3.4-0.7-5.8-2-7.6-2.5c-0.4-0.1-0.8-0.2-1.2-0.2c-2.6,0-4,5,0.7,5
	c5,0,6.2,2.4,4.4,4.8c-0.9,1.2-3.7,1.7-4.5,2.5c-0.8,0.8-2.3,1.5-1.9,4.4c0.3,2.5,0.5,5,2.9,5.5c2.1,0.5,2.8-2.1,2.7-4.1
	c-0.2-3.2,1.5-3.5,3.6-3.5c1,0,4.6,0.1,5.9,1.5c1.2,1.2,1.9,3.6,3.1,5.7c1.2,2.1,4.3,0,4.3-1.5c0-1.5-2.1-5.3-3.5-6.7
	C53.4,55.2,47.9,54.7,47.3,54.1 M71.3,38.5c2.8,0,2.6-2.6,0.6-2.6h-3.5c-2.5,0-4.1-0.7-5.7-2.3c-1.6-1.6-1.2-3.4-0.8-5.4
	c0.3-1.6-0.8-2.3-1.8-2.3c-1.3,0-2.9,1.2-2.9,6.7c0,3.8,3.3,4,4.8,5.5c1.5,1.5,0.7,3.3-0.9,4.8c-1.5,1.5-3.4,1.8-4.1,4.4
	c-0.7,2.7,4.4,14.7,7.5,13.2c3.7-1.8-1.8-8.9-1.8-11.8c0-2.8,2.7-1.9,3.8-1.2c0.9,0.6,1.9,1.4,2.3,4.3c0.4,3.3,2.3,1.2,3.1-0.9
	c0.6-1.5,1.2-4-0.2-5.4c-1.4-1.4-5.5-1.4-5.5-2.1c0-0.7,0-4,0.8-4.9C67.9,37.6,68.5,38.5,71.3,38.5 M67.1,33.3
	c1.5,0,2.3-1.2,2.3-2.3c0-1.2-1.1-1.7-2.2-1.7c-1,0-2,0.4-2.3,1C64.2,31.7,65.6,33.3,67.1,33.3"
		/>
	</>
)
